module.exports = __webpack_public_path__ + "static/media/kementriantng.ec7b365f.png";